import type { Experiments } from '@wix/thunderbolt-symbols'

/*
 * This list contains experiments names that are relevant to code running in site-assets (A.K.A Becky)
 * They are available via envApi.getExperiments() for carmi code and compInfo['experiments'] for components mappers
 * If the code that uses the experiment runs in feature - you don't need to add it here
 * */
export const beckyWhitelist = [
	'sv_UploadButtonFilenameHover',
	'sv_UploadButtonClientSideValidation',
	'googleMapsClientKey',
	'specs.thunderbolt.fontAntiAliased',
	'specs.thunderbolt.breakingBekyCache',
	'specs.thunderbolt.DatePickerPortal',
	'specs.thunderbolt.final_image_auto_encode',
	'specs.thunderbolt.LinkBarPlaceholderImages',
	'specs.thunderbolt.maskImageCSS',
	'specs.thunderbolt.catharsis_theme',
	'specs.thunderbolt.layout_runtime',
	'specs.thunderbolt.new_responsive_layout_render_all_breakpoints',
	'specs.thunderbolt.catharsis_transitions_style',
	'specs.thunderbolt.catharsis_transformations_style',
	'specs.thunderbolt.optimizeCSS_variablize',
	'specs.thunderbolt.presenceApi',
	'specs.thunderbolt.presenceWithoutChat',
	'specs.thunderbolt.repeater_keyboard_navigation',
	'specs.thunderbolt.WRichTextResponsiveTagsInBlocksWidget',
	'specs.thunderbolt.WRichTextDefaultSpan',
	'specs.thunderbolt.loadFirstNFonts',
	'specs.thunderbolt.proGalleryMasterInfo',
	'specs.thunderbolt.SlideshowGalleryKeepItemsInTheDOM',
	'specs.thunderbolt.freemiumBannerMobileUsePreferredApp',
	'specs.thunderbolt.forceNoIndexOfProfilePage',
	'specs.thunderbolt.customElemCollapsedheight',
	'specs.thunderbolt.externalComponents',
	'specs.editor-elements.allowRefPointerEventsInEditMode',
	'specs.thunderbolt.pinned_layout_css_catharsis',
	'specs.thunderbolt.shouldUseWowImage',
	'specs.thunderbolt.expandColorPalette',
	'specs.thunderbolt.stylable_catharsis',
	'specs.thunderbolt.StripColumnsContainerMapper',
	'specs.thunderbolt.catharsis_accessibility',
	'specs.thunderbolt.dropdownOptionStyle',
	'specs.thunderbolt.dropdownOptionStyle_loggedIn',
	'specs.PayPalButton.apiv2',
	'specs.thunderbolt.compsMeasuresCss_catharsis',
	'specs.thunderbolt.comps_to_hide_effectsis',
	'specs.thunderbolt.mesh2',
	'specs.thunderbolt.shouldUseViewTransition',
	'specs.thunderbolt.ExpandableMenuFixDirection',
	'specs.thunderbolt.native_css_mappers',
	'specs.thunderbolt.stylableHorizontalMenWithWrapper',
	'specs.thunderbolt.url_hierarchy',
	'specs.thunderbolt.PayPalApiv2',
	'specs.thunderbolt.scaleprop',
	'specs.thunderbolt.useMergedCssSelectors',
	'specs.thunderbolt.new_refArray_overrides',
	'specs.thunderbolt.WRichTextSemanticClasses',
	'specs.thunderbolt.fontFacesFontDisplay',
	'specs.thunderbolt.OOICssForWidgetsWithAppSettings',
	'specs.thunderbolt.shapeDividersDropShadowFix',
	'specs.thunderbolt.panelbuilder_velo_migration',
	'specs.thunderbolt.ooi_css_vars',
	'specs.thunderbolt.nativeAspectRatio',
	'specs.thunderbolt.useRuntimeDataSchemasV2',
	'specs.thunderbolt.compute_css_by_active_variant',
	'specs.thunderbolt.compute_css_by_active_breakpoints',
	'specs.thunderbolt.displayRefComponentsAsBlock',
	'specs.thunderbolt.edixIsInFirstFold',
	'specs.thunderbolt.responsiveShapeDividers',
	'specs.thunderbolt.responsiveShapeDividersPublic',
	'specs.thunderbolt.DDMenuMigrateCssCarmiMapper',
	'specs.thunderbolt.shouldExportCurrentConsentPolicy',
	'specs.thunderbolt.supportSpxInEEMappers',
	'specs.thunderbolt.interactionsOverrides',
	'specs.thunderbolt.wixSitesFontDisplaySwap',
	'useTranslatedUrlSlugs',
	// ------- catharsis experiments -------
	'specs.thunderbolt.catharsis_fontFaces',
	'specs.thunderbolt.catharsis_auto_height_wrapper',
	'specs.thunderbolt.catharsis_cursor',
	'specs.thunderbolt.AnalyticsElementsClicks',
	'specs.thunderbolt.layouterNavigationConsumption',
] as const

export type beckyWhitelistSpecType = typeof beckyWhitelist[number]

/*
 * This list contains experiments names that are relevant to data-fixer code running in site-assets
 * They are passed to becky (site-assets modules) so that it can get fixed JSONs as input
 * Add only data-fixers experiments relevant to TB (they will be sent only if the experiment is open in thunderbolt-viewer scope)
 * */
export const dataFixersSpecsWhitelist = [
	'sv_migrateTpaToSemiNative',
	'bv_migrateAbsoluteLayoutToDataMaps',
	'bv_scrollEffectsFixer',
	'bv_migrate',
	'bv_migrateResponsiveLayoutToSingleLayoutData',
	'dm_removeMissingResponsiveRefs',
	'bv_removeMenuDataFromPageJson',
	'dm_fixMobileSplitInVariantNs',
	'dm_fixMobileSplitDesign',
	'dm_migrateToTextTheme',
	'dm_keepChildlessAppWidget',
	'dm_removeResponsiveDataFromClassicEditorFixer',
	'dm_enableDefaultA11ySettings',
	'dm_linkRelDefaults',
]

/*
 * This list contains experiments names that are relevant to data-fixer code running in site-assets
 * They are passed to becky (site-assets modules) so that it can get fixed JSONs as input
 * These experiments are always sent, regardless of conduction in thunderbolt-viewer scope.
 * */
export const hardCodedListOfDataFixersExperiments: Experiments = {
	bv_remove_add_chat_viewer_fixer: 'new',
}
